import {Component} from '@angular/core';
import {CookieService} from "./services/cookie.service";
import {ActivatedRoute, RouterOutlet} from "@angular/router";
import {ThemeService} from "./services/theme.service";
import {CalculatorIndexComponent} from "./calculator-index/calculator-index.component";
import {AgeCalculationService} from "./services/age-calculation.service";
import {RciApiService} from "./services/rci-api.service";
import {ModelService} from "./services/model.service";

import {DecimalPipe} from "@angular/common";
import {environment} from "../environments/environment";
import {LoaderComponent} from "./loader/loader.component";
import {FormsModule} from "@angular/forms";
import 'zone.js';

import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';

registerLocaleData(localeDe, 'de-DE', localeDeExtra);

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [
    RouterOutlet,
    LoaderComponent,
    FormsModule
  ],
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'online-calculator';
  cookieEnabled: boolean = false;
  cookiePageUrl: string;
  privacyPageUrl: string;
  brand: string;
  bankName: string;
  bankShortName: string;
  bankNameForCookie: string;
  calculator = new CalculatorIndexComponent(this.cookieService, this.themeService, this.ageCalculation, this.rciApi, this.activatedRoute, this.model, this.decimalPipe);

  constructor(public cookieService: CookieService,
              public themeService: ThemeService,
              public ageCalculation: AgeCalculationService,
              public rciApi: RciApiService,
              public activatedRoute: ActivatedRoute,
              public model: ModelService,
              private decimalPipe: DecimalPipe) {
    // this.rciApi.initializeConfig();
  }

  ngOnInit(): void {
    if (!this.cookieEnabled) {
      this.cookieEnabled = this.cookieService.isCookieEnabled();
    }
    this.activatedRoute.queryParams.subscribe(params => {
      this.brand = params.brand;
      this.setBankName(this.brand);
      this.themeService.setThemeByBrandCode(this.brand, 'skyscraper');
      this.cookiePageUrl = environment.budgetcalcUrl + "/cookies?brand=" + this.brand;
      this.privacyPageUrl = environment.budgetcalcUrl + "/privacycustomer?brand=" + this.brand;
    });
  }

  setBankName(brand: string): string {
    this.bankName = 'RCI Banque S.A. Niederlassung Deutschland (RCI)';
    this.bankShortName = 'RCI Banque S.A. Niederlassung Deutschland';
    this.bankNameForCookie = 'RCI Banque S.A. Niederlassung Deutschland';
    if (!brand) {
      return;
    }
    switch (brand) {
      case 'REN':
        this.bankName = 'Mobilize Financial Services, Geschäftsbereich der ' + this.bankName;
        this.bankShortName = 'Mobilize Financial Services';
        this.bankNameForCookie = 'Renault und Mobilize Financial Services';
        break;
      case 'DAC':
        this.bankName = 'Mobilize Financial Services, Geschäftsbereich der ' + this.bankName;
        this.bankShortName = 'Mobilize Financial Services';
        this.bankNameForCookie = 'Dacia und Mobilize Financial Services';
        break;
      case 'NIS':
        this.bankName = 'Nissan Financial Services, Geschäftsbereich der ' + this.bankName;
        this.bankShortName = 'Nissan Financial Services';
        this.bankNameForCookie = 'Nissan und Nissan Financial Services';
        break;
    }
  }

  enableCookie() {
    this.cookieEnabled = true;
    this.cookieService.enableCookie();
    if (this.cookieService.isCookieEnabled()) {
      // this.calculator.ngOnInit();
      window.location.reload();
    } else {
      this.cookieService.cookieAsked = true;
      this.calculator.ngOnInit();
    }
  }

  rejectCookie() {
    let cookieWasSelected = this.cookieEnabled;
    this.cookieService.cookieAsked = true;
    this.cookieEnabled = false;
    if (cookieWasSelected) {
      this.cookieService.removeCookies();
      window.location.reload();
    }
    this.calculator.ngOnInit();
  }
}
